(function () {
	const searchModal = () => {
		$(".search-modal-trigger,.search-modal__mask,.search-modal__close").click(
			function (e) {
				e.preventDefault();
				searchToggle()
			}
		);
	};
	$(document).on('keyup', function(e) {
		if ($("#search-modal").hasClass('active') && e.key == "Escape") {
			searchToggle()
		}
	});
	function searchToggle(){
		$("#search-modal,.search-modal__mask").toggleClass("active");
		if ($("#search-modal").hasClass('active')) {
			if (window.innerWidth > 1200) {
				document.querySelector("#search-modal .search__input")?.focus();
			}
				document.querySelector('.search-pill-form').style.display = 'none'
		} else {
			$(".search-modal-trigger").focus();
				document.querySelector('.search-pill-form').style.display = 'flex'
			if (window.innerWidth > 1200) {
			}
		}
		$('body').toggleClass("overflow-hidden")
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
